import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  chart: {
    title: null,
    series: [],
    chartOptions: {
      status: {
        loading: false,
        noData: false
      },
      chart: {
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: '17'
        }
      },
      colors: ['#56aee3', '#745af2'],
      labels: [],
      grid: {
        curve: 'smooth',
        lineCap: 'butt',
        strokeDashArray: 3
      },
      stroke: {
        width: [0, 3]
      },
      legend: {
        show: false
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'vertical',
          shadeIntensity: 0.2,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100]
        }
      },
      xaxis: {
        type: 'category',
        categories: [],
        labels: {
          show: true
        }
      },
      yaxis: [
        {
          opposite: false,
          title: {
            text: 'Average',
            offsetX: -5,
            style: {
              color: '#fff',
              fontSize: '12px',
              cssClass: 'apexcharts-yaxis-title'
            }
          }
        },
        {
          opposite: true,
          title: {
            text: 'Product Number',
            offsetX: 5,
            style: {
              color: '#fff',
              fontSize: '12px',
              cssClass: 'apexcharts-yaxis-title'
            }
          }
        }]
    }
  }
}

const getters = {

}

let elemRef = null

const actions = {
  getChart ({commit}, filter) {
    elemRef = filter.elementRef
    commit('SET_loading', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'pricesDeviation',
        payload: {
          sellers: filter.sellers,
          categories: filter.categories,
          brands: filter.brands
        }
      })
        .then(response => {
          console.log('pricesDeviation', response.data.payload)
          commit('SET_title', response.data.payload.title)
          if (response.data.payload.distributions.length) {
            commit('SET_noData', false)
            commit('SET_Chart', response.data.payload.distributions)
          } else {
            commit('SET_noData', true)
          }
          commit('SET_loading', false)
          resolve()
          if (elemRef) {
            elemRef.refresh()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_loading (state, bool) {
    state.chart.chartOptions.status.loading = bool
  },
  SET_noData (state, bool) {
    state.chart.chartOptions.status.noData = bool
    if (bool) {
      state.chart.series = []
    }
  },
  SET_Chart (state, data) {
    let productsNumber = data.map(el => {
      return el.products_number
    })
    let avgNumber = data.map(el => {
      return el.avg_price
    })
    let sellerNames = data.map(el => {
      return el.seller_name
    })
    state.chart.chartOptions.xaxis.categories = []
    state.chart.chartOptions.xaxis.categories = sellerNames
    console.log('sellerNames', sellerNames)

    state.chart.series = []
    state.chart.series.push(
      {
        name: 'Product',
        type: 'column',
        data: productsNumber
      }
    )
    state.chart.series.push(
      {
        name: 'Average',
        type: 'line',
        data: avgNumber
      }
    )
  },
  SET_title (state, data) {
    state.chart.title = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics/averageDeviation.js